import { render } from "./index.vue?vue&type=template&id=0e98a0da&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=0e98a0da&scoped=true&lang=scss"

import exportComponent from "/builds/gh_devops/fund_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e98a0da"]])

export default __exports__